import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Language, UserImp, UsersService } from '@ubie/core';
import { FeedbackService } from '@ubie/shared';

@Component({
  selector: 'acl-owner-form',
  standalone: false,
  templateUrl: './owner-form.component.html',
  styleUrl: './owner-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerFormComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly userService = inject(UsersService);
  private readonly feedbackService = inject(FeedbackService);
  private readonly translateService = inject(TranslateService);

  readonly user = input<UserImp | undefined>(undefined);

  // owner form group
  ownerForm: FormGroup = this.formBuilder.group({
    id: [],
    firstName: [''],
    lastName: [''],
    language: [''],
    email: [''],
    telephone: [''],
  });

  readonly languages = signal<Language[]>([]);

  readonly canEnable = signal(false);
  isFormSubmitAttempted = false;

  isUpdateSuccess = false;
  isUpdating = false;

  constructor() {
    effect(() => {
      const user = this.user();

      if (user) {
        this.ownerForm.setValue({
          id: user.id,
          firstName: user.firstname,
          lastName: user.lastname,
          language: user.language.id,
          email: user.email,
          telephone: user.telephone ?? null,
        });
      }
    });
  }

  ngOnInit(): void {
    this.ownerForm.disable();
    this.languages.set(this.route.snapshot?.data['languages']);
  }

  onUpdateOwner(): void {
    this.isFormSubmitAttempted = true;
    // copy the form values over the object values
    if (this.ownerForm.valid) {
      const obj = {
        ...this.user,
        ...this.ownerForm.value,
      };

      this.userService.updateUser(obj).subscribe({
        next: () => {
          this.isFormSubmitAttempted = false;
          // update success
          this.isUpdateSuccess = true;
          // set updating bool to false: a check mark will show instead of a loader
          this.isUpdating = false;

          this.feedbackService.present(
            this.translateService.instant('installation_updateSuccess'),
            2000,
            true,
            'medium',
          );
        },
        error: (error) => {
          // update failed
          this.isUpdateSuccess = false;
          // set updating bool to false: a check mark will show instead of a loader
          this.isUpdating = false;

          this.feedbackService.present(
            error.errorMessage,
            5000,
            true,
            'danger',
          );
        },
      });
    }
  }
}
